module.exports = __webpack_public_path__ + "img/complete-vehicle.86bde6fe.png";